import { getAxiosInstance } from '@utils/request';
import { Extent } from 'ol/extent';

export interface Settings {
  project: {
    title: string | null;
    logo_url: string | null;
    default_map_extent: Extent | null;
    default_map_srid: number | null;
    default_map_name: string | null;
  };
}

export class GetSettings {
  readonly url = 'api/settings';

  async get() {
    const response = await getAxiosInstance().get<Settings>(`${this.url}/`);

    return response.project;
  }
}
